import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=3366e76d&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3366e76d')) {
      api.createRecord('3366e76d', component.options)
    } else {
      api.reload('3366e76d', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=3366e76d&", function () {
      api.rerender('3366e76d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R9Yl4BeyUCTb/JS/offershelp.vue"
export default component.exports